import React from 'react';
import './VideosSection.css';
import { useTranslation } from '../contexts/TranslationContext';
import { VideoContent } from '../types/video';
import { getVideosSectionItems } from '../data/videoLibrary';
import VideoPreview from './VideoPreview';

interface VideosSectionProps {
  onVideoClick: (video: VideoContent) => void;
}

const VideosSection: React.FC<VideosSectionProps> = ({ onVideoClick }) => {
  const { t } = useTranslation();
  const videos = getVideosSectionItems(8);

  return (
    <div className="videos-section">
      <div className="videos-container">
        <h2 className="videos-title">{t('homepage.videos.title')}</h2>
        <div className="videos-content">
          <p className="videos-description">
            {t('homepage.videos.subtitle')}
          </p>
          <div className="videos-grid">
            {videos.map((video) => (
              <button
                key={video.title}
                type="button"
                className="videos-section-card"
                onClick={() => onVideoClick(video)}
              >
                <VideoPreview
                  video={video.video}
                  title={video.title}
                  className="videos-section-preview-wrap"
                  showBadge={false}
                />
                <span className="videos-section-card-title">{video.title}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideosSection;
